import React, { Component } from 'react';
import '../App.css';

export default class FooterSection extends Component {
  render() {
    return (
        <div className="Footer">
            <h3>Feel free to reach out to me if you like the site! My details can be found on my CV!</h3>
        </div>

      );
    
  }
}
